import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export type HttpClientProps = {
  host: string;
  key: string;
};

export type ApiClientProps = {
  client: AxiosInstance;
};

export type AuthCode = { code: string };
export type AuthResponse = { groups: string[] };

export interface User {
  //  username: string;
  email: string;
  groups: string[];
}

export interface LogoutResponse {
  logoutUrl: string;
}

export class HttpClient {
  public axios: AxiosInstance;

  constructor(props: ApiClientProps) {
    this.axios = props.client;
  }

  static create(props?: HttpClientProps) {
    const config = {
      baseURL: props?.host || process.env.API_HOST,
      withCredentials: true,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
        'x-api-key': props?.key || process.env.API_KEY,
      },
    } as AxiosRequestConfig;

    return new HttpClient({ client: axios.create(config) });
  }

  loginUser(code: string) {
    return this.axios.post<AuthCode, AxiosResponse<AuthResponse>>(
      'authenticate',
      {
        code,
      }
    );
  }

  logoutUser(data = {}) {
    return this.axios.post<LogoutResponse>('logout', data);
  }
}
